"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXTS = void 0;
exports.TEXTS = {
    stepOne: {
        title: '',
        subTitle: 'כתבו את הסיפור שלכם, צרפו תמונות ונעשה כל מאמץ לפרסם את הזיכרון שלכם',
        fields: {
            soldierName: {
                label: 'שמי / שם החייל שעליו אספר',
                placeholder: 'ישראל ישראלי',
            },
            story: {
                label: '',
                placeholder: 'הזיכרון שלי מתחיל ב...',
            },
            picture: {
                label: 'העלאת תמונה',
            },
            name: {
                label: 'שמך',
                placeholder: 'ישראל ישראלי',
            },
            email: {
                label: 'כתובת מייל',
                placeholder: 'mail@adress.co.il',
            },
            confirmation: {
                label: "\u05D0\u05E0\u05D9 \u05D4\u05D1\u05E2\u05DC\u05D9\u05DD \u05E9\u05DC \u05D4\u05E7\u05E0\u05D9\u05D9\u05DF \u05D4\u05E8\u05D5\u05D7\u05E0\u05D9 \u05DC\u05E8\u05D1\u05D5\u05EA \u05D6\u05DB\u05D5\u05D9\u05D5\u05EA \u05D4\u05D9\u05D5\u05E6\u05E8\u05D9\u05DD \u05D1\u05E6\u05D9\u05DC\u05D5\u05DD \u05E9\u05D4\u05E2\u05DC\u05D9\u05EA\u05D9 \u05D5\u05D0\u05E0\u05D9 \u05DE\u05D0\u05E9\u05E8/\u05EA \u05DC\u05D7\u05D1\u05E8\u05EA \u05D4\u05D7\u05D3\u05E9\u05D5\u05EA \u05D4\u05D9\u05E9\u05E8\u05D0\u05DC\u05D9\u05EA \u05D1\u05E2\"\u05DE \u05D5\u05DC\u05E9\u05D9\u05D3\u05D5\u05E8\u05D9 \u05E7\u05E9\u05EA \u05D1\u05E2\"\u05DE \u05DC\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05E6\u05D9\u05DC\u05D5\u05DD \u05E2\u05DC \u05E4\u05D9 \u05E9\u05D9\u05E7\u05D5\u05DC \u05D3\u05E2\u05EA\u05D4 \u05D4\u05D1\u05DC\u05E2\u05D3\u05D9, \u05DC\u05DB\u05DC \u05E6\u05D5\u05E8\u05DA \u05E9\u05D4\u05D5\u05D0, \u05D1\u05DB\u05DC \u05E4\u05DC\u05D8\u05E4\u05D5\u05E8\u05DE\u05D4 \u05E9\u05D4\u05D9\u05D0, \u05E7\u05D9\u05D9\u05DE\u05EA \u05D0\u05D5 \u05E2\u05EA\u05D9\u05D3\u05D9\u05EA",
            },
        },
        photosAmountRestriction: 'ניתן להעלות עד 3 תמונות במשקל כולל של עד 10MB ',
    },
    final: {
        title: 'תודה ששיתפתם',
        subTitle: 'נעבור על הסיפור וייתכן שניצור איתך קשר להשלמת פרטים.',
        text: 'הסיפורים והתמונות יצטרפו ליומן הזיכרונות המשותף של N12',
    },
    sendBtn: 'שליחה',
    validation: {
        required: 'שדה חובה',
        invalidValue: 'ערך לא תקין',
        stepOne: {
            soldierName: {
                required: 'יש לעדכן שם כדי לשלוח את הפרטים',
                invalidValue: 'יש להזין שם מלא',
            },
            name: {
                required: 'יש לעדכן שם כדי לשלוח את הפרטים',
                invalidValue: 'יש להזין שם מלא',
            },
            email: {
                required: 'יש לעדכן כתובת מייל תקינה',
                invalidValue: 'יש לעדכן כתובת מייל תקינה',
            },
            confirmation: {
                required: 'יש לאשר סעיף זה כדי להתקדם',
            },
        },
    },
};
//# sourceMappingURL=client-form.js.map